import {useMutation} from '@tanstack/react-query';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';

interface Response extends BackendResponse {}

export function useLogoutSession() {
  return useMutation((sessionId: number) => logoutSession(sessionId), {
    onError: err => showHttpErrorToast(err),
  });
}

function logoutSession(sessionId: number): Promise<Response> {
  return apiClient.delete(`user-sessions/${sessionId}`).then(response => response.data);
}
